import { h } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { useContext } from 'preact/compat'
import SurveyContext from 'contexts/survey-context'

import classes from './progressBar.scss'
import { FormFieldType } from 'scripts/type'

const reservedProgress = 5

const ProgressBar = () => {
  const { pages, activePageIndex, lastSubmitFieldCode } = useContext(SurveyContext)
  const { startIndex: rawStartIndex, totalCount, nodes } = pages[activePageIndex] ?? { nodes: [] }
  const startIndex = rawStartIndex ?? 0
  const [currentIndex, setCurrentIndex] = useState(startIndex)

  useEffect(() => {
    const isEndingPage = nodes.some(({ type }) => type === FormFieldType.EndingField)
    setCurrentIndex(isEndingPage ? totalCount ?? 0 : startIndex)
  }, [startIndex, nodes, totalCount])

  useEffect(() => {
    if (lastSubmitFieldCode) {
      const indexOnCurrentPage = nodes.findIndex(({ code }) => code === lastSubmitFieldCode)
      const newIndex = indexOnCurrentPage > -1 ? startIndex + indexOnCurrentPage : currentIndex
      currentIndex < newIndex && setCurrentIndex(newIndex)
    }
  }, [lastSubmitFieldCode])

  const realProgress = totalCount ? Math.round((currentIndex * 100) / totalCount) : 100
  const progress = reservedProgress + (realProgress * (100 - reservedProgress)) / 100

  return (
    <div className={classes.progressRoot}>
      <div className={classes.progressBar} style={{ width: `${progress}%` }}></div>
    </div>
  )
}

export default ProgressBar
